import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { cloneDeep, uniqBy } from 'lodash';
import { LoaderService } from 'src/app/components/loader/loader.service';
import { PermissionsManagerService } from 'src/app/services/common/permissions-manager.service';
import { SnackbarService } from 'src/app/services/common/snackbar.service';
import { UserPermissions } from 'src/app/services/common/user-role';
import { HealthAppService } from 'src/app/services/explore-health/health-app.service';
import { Constants } from 'src/app/utils/constants';

@Component({
  selector: 'app-support-request-dialog',
  templateUrl: './support-request-dialog.component.html',
  styleUrls: ['./support-request-dialog.component.scss'],
  standalone: false,
})
export class SupportRequestDialogComponent implements OnInit {
  loading = false;
  acceptFileTypes = Constants.ATTACHMENTALLFILETYPES;
  selectedFiles: File[] = [];
  maxAllowedSize = 2097152;

  newRequesPayload: any = {
    requestId: 0,
    status: 'In Progress',
    priority: '',
    moduleName: '',
    subject: '',
    description: '',
    resolution: '',
    fileUploads: [],
  };

  isHavingSupportActionsPermission: boolean = false;

  constructor(
    public haService: HealthAppService,
    public loader: LoaderService,
    @Inject(MAT_DIALOG_DATA) public dataInstance: any,
    public dialogRef: MatDialogRef<SupportRequestDialogComponent>,
    private readonly snack: SnackbarService,
    private readonly permissionManager: PermissionsManagerService,
  ) {
    this.isHavingSupportActionsPermission = this.permissionManager.has(
      UserPermissions.SUPPORT_ACTIONS,
    );
  }

  ngOnInit(): void {
    if (this.dataInstance.isUpdating) {
      this.newRequesPayload = cloneDeep(this.dataInstance.dataForEdit);
      this.newRequesPayload.moduleName =
        this.dataInstance?.dataForEdit?.moduleName?.length > 0
          ? this.dataInstance.dataForEdit.moduleName
          : 'Others';
    }
  }

  cancelClicked() {
    this.dialogRef.close();
  }

  create() {
    this.loader.showLoader();

    if (
      this.dataInstance.isUpdating &&
      !this.isHavingSupportActionsPermission
    ) {
      this.newRequesPayload.status = 'In Progress';
    }

    this.haService
      .createSupportRequest(
        this.newRequesPayload,
        this.selectedFiles,
        this.dataInstance.isUpdating,
      )
      .subscribe({
        next: (response: any) => {
          this.loader.hideLoader();
          this.dialogRef.close({
            refresh: true,
          });
        },
        error: (error) => {
          this.loader.hideLoader();
          if (error?.error?.error?.length > 0) {
            this.snack.openErrorBar(error.error.error.join(','));
          }
        },
        complete: () => {},
      });
  }

  handleFileInputClick(filesInputEvent: any) {
    if (filesInputEvent) {
      filesInputEvent.target.value = '';
    }
  }

  clearUploadedFiles() {
    this.selectedFiles = [];
  }

  handleFileInput(filesInputEvent: any) {
    if (filesInputEvent) {
      if (!this.selectedFiles) {
        this.selectedFiles = [];
      }

      let temp: any = [];
      for (let file of filesInputEvent.target.files) {
        temp.push(file);
      }

      if (
        !temp?.every(
          (it: any) =>
            String(it.name).endsWith('.docx') ||
            String(it.name).endsWith('.doc') ||
            it.type == 'image/png' ||
            it.type == 'image/jpeg' ||
            it.type == 'application/pdf',
        )
      ) {
        this.snack.openInfoBar(
          'Only .pdf,.docx,.jpg,.png,.jpeg, extensions are allowed!',
          'Ok',
          10,
        );
        return;
      }

      let count = this.selectedFiles.length + temp.length;
      if (this.newRequesPayload?.isUpdating) {
        count = count + this.newRequesPayload?.fileUploads?.length;
      }
      if (count > 2) {
        this.snack.openInfoBar(
          'Maximum number of files allowed are two only!',
          'Ok',
          10,
        );
        return;
      }

      for (let file of this.selectedFiles) {
        temp.push(file);
      }

      let greaterThan1Mb: boolean = false;
      temp.forEach((it: any) => {
        if (it.size > this.maxAllowedSize) {
          greaterThan1Mb = true;
        }
      });

      if (greaterThan1Mb) {
        this.snack.openInfoBar(
          `Maximum allowed file size is ${Math.floor(
            this.maxAllowedSize / 1048576,
          )} MB per attachment!`,
          'Ok',
          10,
        );
        return;
      }

      this.selectedFiles = [
        ...this.selectedFiles,
        ...filesInputEvent.target.files,
      ];

      this.selectedFiles = uniqBy(this.selectedFiles, 'name'); //.filter((it: File)=> );
    }
  }

  validPayload() {
    return (
      !this.newRequesPayload.priority ||
      !this.newRequesPayload.subject ||
      !this.newRequesPayload.description
    );
  }

  openFile(file: any) {
    if (file.downloadUrl) {
      window.open(file.downloadUrl, '_blank');
    } else {
      this.snack.openInfoBar(
        'File not available for download. Please contact support.',
      );
    }
  }
}
